import * as React from "react"
import { Navigate } from "react-router-dom"

import { MONITORING_ROUTES } from "@constants"
import AppLayout from "Layout"
import MonitoringResultsPage from "./Results";
import MonitoringAdminPage from "./Admin";

export const MonitoringRoutes = {
    path: MONITORING_ROUTES.PATH,
    title: MONITORING_ROUTES.TITLE,
    accessKey: MONITORING_ROUTES.ACCESS_KEY,
    icon: 'chart-fft',
    description: MONITORING_ROUTES.SUBTITLE,
    element: <AppLayout />,
    children: [{
        element: <Navigate to={MONITORING_ROUTES.OVERVIEW_PATH} replace />,  index: true
    }, {
        title: MONITORING_ROUTES.OVERVIEW_TITLE,
        path: MONITORING_ROUTES.OVERVIEW_PATH,
        dashboardKey: MONITORING_ROUTES.OVERVIEW_ID,
        element: <MonitoringResultsPage />
    }, {
        title: MONITORING_ROUTES.ADMIN_TITLE,
        path: MONITORING_ROUTES.ADMIN_PATH,
        dashboardKey: MONITORING_ROUTES.ADMIN_ID,
        element: <MonitoringAdminPage />
    }]
}